import React, { useState } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { Button, Flex, Modal } from 'antd';
import { toast } from 'react-toastify';
import { WhatsappGroup } from 'src/interfaces/entities/whatsappGroup';
import {
	useDeleteWhatsappGroupMutation
} from 'src/redux/services/centralApi';

export default function DeleteGroup({ row, }: { row: WhatsappGroup }) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ deleteGroup, deleteGroupResult, ] = useDeleteWhatsappGroupMutation();

	return (
		<>
			<Button
				type="text"
				danger
				icon={<DeleteOutlined />}
				onClick={() => setOpen(true)}
			/>
			<Modal
            
            
				centered
				title={'Excluir Grupo do Whatsapp'}
				open={open}
				onCancel={() => {
					setOpen(!open);
					toast.info('Operação cancelada!', { autoClose: 1000, });
				}}
				destroyOnHidden
				okText="Excluir"
				onOk={() =>
					deleteGroup(row.groupId ?? '')
						.unwrap()
						.then(() => {
							setOpen(false);
							toast.success('Grupo deletado com sucesso!', {
								autoClose: 1000,
							});
						})
						.catch((err) => {
							if (
								err?.status &&
								err?.status === 500 &&
								err?.data?.frontend_message
							) {
								toast.error(err?.data?.frontend_message, {
									autoClose: 1000,
								});
							}
						})
				}
				confirmLoading={deleteGroupResult.isLoading}
			>
				<Flex>
					{`Tem certeza que deseja deletar o grupo ${row.name}? Esta ação retirará todos os participantes do grupo!`}
				</Flex>
			</Modal>
		</>
	);
}
